import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React from "react";
import HTRadioGroup from "../../../components/HTRadioGroup";
import Lang from "../../../components/Lang";
import VND from "../../../components/VND";
import Text from "../../../components/Text";
import mut from "../../../hooks/mut";

export default function NewCourseDialog(props) {
    const { open, setOpen } = props;
    const [lessons, setLessons] = React.useState(40);
    const [amount, setAmount] = React.useState("");
    const [otherNumber, setOtherNumber] = React.useState("");
    const [description, setDescription] = React.useState("");

  /*   const [information, setInformation, error, loading] = useDB("/sales-dialog")
    if (loading) return <Loading />
    if (error) return <Error />
     */
   
    const go = async () => {
        await mut("put", "/sales", { amount, numberOfLessons: otherNumber || lessons, description, })
        setAmount("")
        setOtherNumber("")
        setDescription("")
        setOpen(false);
    }

  return (
    <Dialog
      open={open}
      fullWidth
    >
      <DialogTitle>
        <Lang w="addANewCourse" />
      </DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <div style={{ display: "flex" }}>
            <HTRadioGroup
              list={list.map((item) => ({
                _id: item,
                name:
                  item !== -1 ? (
                    <div>
                      {item} <Lang w="lessons" />
                    </div>
                  ) : (
                    <div>
                      <Lang w="otherNumber" />
                    </div>
                  ),
              }))}
              value={lessons}
              setValue={setLessons}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column-reverse",
                marginLeft: 10,
              }}
            >
                          {lessons === "-1" && <Text
                              value={otherNumber}
                              type="number"
                              setValue={setOtherNumber}
                              label={<Lang w="lessons" />}
                              size="small"
                              disabled={lessons !== "-1"}
                          />}
            </div>
          </div>
          <Text
            value={description}
            setValue={setDescription}
            label={<Lang w="description" />}
            multiline
            rows={3}
            fontSize={12}
          />
          <VND
            label={<Lang w="fee" />}
            value={amount}
            setValue={setAmount}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
        <Button color="success" onClick={go} disabled={!description || !amount || (lessons==="-1" && !otherNumber)}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}

const list = [10, 20, 40, 80, -1];